export const API_DOMAIN = 'https://api.trubeninvestment.com';
export const API_VERSION = '/v0.1';
export const API_BOARD = API_DOMAIN + API_VERSION + '/board';
export const API_IMAGE_MAKE = API_DOMAIN + API_VERSION + '/image';
export const API_IMAGE = API_DOMAIN;
export const API_SEARCH = API_DOMAIN + API_VERSION + '/search';
export const API_LOGIN = API_DOMAIN + API_VERSION + '/user/login';
export const API_VAILD = API_DOMAIN + API_VERSION + '/token/valid';
